angular.module('core').filter('grade', ['dblMathService',
    function(dblMathService) {
        return function(gradeId, short) {
            if(_.isUndefined(gradeId) ) {
              return '';
            }

            if( _.isNaN(parseInt(gradeId))) {
              switch (gradeId) {
                case 'PreK':
                    return 'Pre-K';
                case 'Kindergarten':
                    return short ? 'K' : 'Kindergarten';
                default:
                    return '';
              }
            }

            switch (parseInt(gradeId)) {
                case -1:
                    return 'Pre-K';
                case 0:
                    return short ? 'K' : 'Kindergarten';
                case 1000:
                    return 'Multi-Grade';
                case 1001:
                    // 1001 is the code for 'other'
                    return 'Multi-Grade';
                default:
                    return short ? dblMathService.getOrdinal(gradeId) : 'Grade ' + gradeId;
            }
        };
    }
]);
